// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"1bcb930f","453":"4ee4810e"}[chunkId] + ".chunk.js";
};